import {
  format,
  formatDistanceStrict,
  FormatDistanceStrictOptions,
  FormatOptions,
  differenceInDays,
  FormatDistanceOptions,
  formatDistance,
} from 'date-fns';
import { notUndefined } from 'mir-utils/utils/utilities';
import { i18n, I18nextLocale } from '../i18n';
import { I18NEXT_TO_DATE_FNS_LOCALE } from '../i18n/constants';
import { AnalyzeTimeParams, TColoredText } from './types';

export const idecoFormatDate = (
  date: Date | number,
  formatStr: string = 'PP',
  options?: FormatOptions
) =>
  format(date, formatStr, {
    ...options,
    locale: notUndefined(I18NEXT_TO_DATE_FNS_LOCALE.get(i18n.language as I18nextLocale)),
  });

export const idecoFormatDateDistanceStrict = (
  date: Date | number,
  now: Date | number,
  options?: FormatDistanceStrictOptions
) =>
  formatDistanceStrict(date, now, {
    ...options,
    locale: notUndefined(I18NEXT_TO_DATE_FNS_LOCALE.get(i18n.language as I18nextLocale)),
  });

export const idecoFormatDateDistance = (
  date: Date | number,
  now: Date | number,
  options?: FormatDistanceOptions
) =>
  formatDistance(date, now, {
    ...options,
    addSuffix: true,
    includeSeconds: true,
    locale: notUndefined(I18NEXT_TO_DATE_FNS_LOCALE.get(i18n.language as I18nextLocale)),
  });

export const getMessageAndColorForExpirationTime = ({
  date,
  now,
  successStatusDays = 30,
  warningStatusDays = 14,
  hideRelative = false,
}: AnalyzeTimeParams): readonly [string, TColoredText] => {
  const message = hideRelative
    ? idecoFormatDate(date, 'PPPp')
    : `${idecoFormatDateDistanceStrict(date, now, {
        addSuffix: true,
      })}, ${idecoFormatDate(date, 'PPPPp')}`;

  const expirationInDays = differenceInDays(date, now);

  if (expirationInDays <= warningStatusDays) {
    return [message, 'error'];
  }

  if (expirationInDays <= successStatusDays) {
    return [message, 'warning'];
  }

  return [message, 'success'];
};
